import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {
  CounsellingSessionReviewComponent,
  CounsellorEvaluation
} from "../counselling-session-review/counselling-session-review.component";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {CounsellingSessionReviewService} from "../counselling-session-review.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {LogService} from "../../../../../services/log.service";
import {AddIndividualSessionComponent} from "../../add-individual-session/add-individual-session.component";
import {FollowUpQuestionComponent} from "../../follow-up-question/follow-up-question.component";
import {FormGroup} from "@angular/forms";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {PermissionService} from "../../../../../components/employee/permission-service.service";
import {
  ViewServicingDetailsComponent
} from "../../../../vehicles/vehicles/view-servicing-details/view-servicing-details.component";
import {
  ViewCounsellingSessionReviewComponent
} from "../view-counselling-session-review/view-counselling-session-review.component";
import {Observable} from "rxjs";
import {EmployeeService} from "../../../../../services/employee.service";
import {SubSink} from "subsink";
import {FinancialYearService} from "../../../../../services/financial-year.service";
@Component({
  selector: 'app-counselling-session-review-list',
  templateUrl: './counselling-session-review-list.component.html',
  styleUrls: ['./counselling-session-review-list.component.scss']
})
export class CounsellingSessionReviewListComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'srNo',
    'sessionDate',
    'counsellor',
    'observedBy',
    'counsellingSkills',
    'interventions',
    'understandingOfProblem',
    'homeProgram',
    'feedback',
    'actions'
  ];

  counsellingWorkForm!: FormGroup;
  @ViewChild(MatPaginator) paginator !: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  counsellors$: Observable<any[]>
  submittedBy: any[] = [];

  dataSource = new MatTableDataSource<CounsellorEvaluation>([]);
  start: Date | undefined
  end: Date | undefined
  private allReviews: any[] = [];
  private subs = new SubSink();

  constructor(private afs: AngularFirestore,
              private dialog: MatDialog,
              private reviewService: CounsellingSessionReviewService,
              private router: Router,
              private mLogService: LogService,
              private readonly matDialog: MatDialog,
              private permissionService: PermissionService,
              private mDialog: MatDialog,
              private readonly mEmployeeService: EmployeeService,
              private readonly financialYearService: FinancialYearService,) {
    this.counsellors$ = this.mEmployeeService.getCounsellers()
    // this.permissionService.debugDumpPermissions();
    //
    // // Check specific permission
    // this.permissionService.hasPermission('Councelling Observation', PermissionType.EDIT)
    //   .subscribe(result => {
    //     console.debug('Permission check result:', result);
    //   });
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
    this.loadReviews();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loadReviews() {
    this.subs.sink = this.reviewService.getAll().subscribe((data: any) => {
      this.allReviews = data; // Store original data
      this.dataSource.data = data;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }


  // onSearch() {
  //   let filteredData = [...this.allReviews];
  //
  //   // Filter by date range
  //   if (this.start && this.end) {
  //     filteredData = filteredData.filter(item => {
  //       const itemDate = item.sessionDate.toDate();
  //       const startDate = new Date(this.start!);
  //       const endDate = new Date(this.end!);
  //
  //       // Set time to start of day for start date and end of day for end date
  //       startDate.setHours(0, 0, 0, 0);
  //       endDate.setHours(23, 59, 59, 999);
  //
  //       return itemDate >= startDate && itemDate <= endDate;
  //     });
  //   }
  //
  //   // Filter by counsellor
  //   if (this.submittedBy && this.submittedBy !== null) {
  //     filteredData = filteredData.filter(item =>
  //       item.counsellor === this.submittedBy
  //     );
  //   }
  //
  //   // Update the table
  //   this.dataSource.data = filteredData;
  //
  //   // Reset paginator to first page
  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }

  onSearch() {
    let filteredData = [...this.allReviews];

    // Filter by date range
    if (this.start && this.end) {
      filteredData = filteredData.filter(item => {
        const itemDate = item.sessionDate.toDate();
        const startDate = new Date(this.start!);
        const endDate = new Date(this.end!);

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        return itemDate >= startDate && itemDate <= endDate;
      });
    }

    // Filter by counsellor
    if (this.submittedBy && this.submittedBy.length > 0) {
      const selectedNames = this.submittedBy.map(c => c.userName);
      filteredData = filteredData.filter(item =>
        selectedNames.includes(item.counsellor)
      );
    }

    // 🔥 FORCE DESCENDING ORDER AGAIN
    filteredData.sort((a, b) =>
      b.sessionDate.toDate().getTime() - a.sessionDate.toDate().getTime()
    );

    this.dataSource.data = filteredData;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

// New onClear function
//   onClear() {
//     this.start = undefined;
//     this.end = undefined;
//     this.submittedBy = null;
//
//     // Reset to original data
//     this.dataSource.data = this.allReviews;
//
//     // Reset paginator to first page
//     if (this.dataSource.paginator) {
//       this.dataSource.paginator.firstPage();
//     }
//   }


  onClear() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
    this.submittedBy = [];

    const sorted = [...this.allReviews].sort((a, b) =>
      b.sessionDate.toDate().getTime() - a.sessionDate.toDate().getTime()
    );
    this.dataSource.data = sorted;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  refreshTable() {
    this.subs.sink = this.reviewService.getAll().subscribe((data: any) => {
      this.allReviews = data;
      this.dataSource.data = data;
      // Reset filters back to the current financial year (picker only, not applied)
      const fy = this.financialYearService.getCurrentFinancialYear();
      this.start = fy.startDate;
      this.end = fy.endDate;
      this.submittedBy = [];
    });
  }



  // edit(row: CounsellorEvaluation) {
  //   this.router.navigate(['/home/counseling/edit-counselling-session-reviews', row.id]);
  // }

  delete(id: string | undefined) {
    if (!id) return;

    if (confirm('Are you sure to delete this Counselling Observation Details ?')) {
      this.reviewService.deleteRow(id)
        .then(() => {
          alert('Counselling Observation Details Deleted Successfully.');
          // Add activity log
          const activity = {
            date: new Date().getTime(),
            section: 'Counselling',
            action: 'Deleted',
            description: `Counselling observation details deleted by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);
        })
        .catch(error => {
          console.error('Error deleting counselling observation details:', error);
          alert('Error deleting counselling observation details!');
        });
    }
  }




  applyFilter(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim().toLowerCase();
    this.dataSource.filter = value;
  }


  // Add() {
  //   this.router.navigate(['/home/counseling/add-counselling-session-reviews']);
  // }

  openIndividualSessionDialog() {
    this.subs.sink = this.matDialog.open(CounsellingSessionReviewComponent, {
      width: '900px',
      height: '90vh',
      disableClose: true,
      data: null   // Add mode
    }).afterClosed().subscribe(res => {
      if (res === 'saved') {
        this.refreshTable(); // Changed from loadReviews()
      }
    });
  }


  viewEdit(row: any) {
    this.subs.sink = this.matDialog.open(CounsellingSessionReviewComponent, {
      width: '900px',
      height: '90vh',
      disableClose: true,
      autoFocus: false,
      data: row   // Edit mode
    }).afterClosed().subscribe(res => {
      if (res === 'updated') {
        this.refreshTable(); // Changed from loadReviews()
      }
    });
  }

  viewServicingDetails(row:any){
    this.mDialog.open(ViewCounsellingSessionReviewComponent, {
      data:row,
      width: '700px'
    })
  }


  protected readonly PermissionType = PermissionType;
}
